import { Table } from 'antd'
import { Image } from 'antd';
import { AvatarView } from '../../components/avatar/AvatarView'
import { TextGradient } from '../../components/textGradient/TextGradient'
import styles from './ProfilePage.module.css'
import {columns} from './RaitengTableProps'
import { useEffect, useRef, useState } from 'react'
import { ActivityType, getDescriptionActivity, userLogin, UserProfileRateDomain } from '../../models/commonModels'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { changeAvatar, getUserProfile } from '../../store/profile-slice/ProfileSlice'
import notification from './../../image/ic_notification.svg'
import backButton from "./../../image/ic_back_button.png"
import { useNavigate } from 'react-router-dom'
import { setProfileId } from '../../store/app-slice/AppSlice'
import { Modal } from '../../components/modal/Modal'
import { LogOut } from './LogOut'
import { ActivityBar } from '../../components/ActivityBar/ActivityBar'
export const ProfilePage = ({userId}:{userId?:number|null}) =>{
    const dispathc:any = useAppDispatch();
    const activity = useAppSelector(state=>state.appStore.activity_type)
    const user = useAppSelector(state=>state.profileStore.user)
    const inputRef = useRef<HTMLInputElement>(null);
    const [isFirst,setIsFerst] = useState(true)
    const [loqOut, setLogOut] = useState(false)
    const navigation = useNavigate();
    useEffect(()=>{
        if(userId!=null){
            activity!=null&&dispathc(getUserProfile(userId,activity,isFirst))
            setIsFerst(false)
            return;
        }
        const savedUser = localStorage.getItem("currentUser")
        if(savedUser!=null) {
            const initialValue:userLogin = JSON.parse(savedUser)
            activity!=null&&dispathc(getUserProfile(null,activity,isFirst))
            setIsFerst(false)
        }
        
    },[activity])

    const handleFileChange = (event:React.ChangeEvent<HTMLInputElement>)=>{
        if(event.target.files){
            if(event.target.files.length>0){
                dispathc(changeAvatar(event.target.files[0]))
            }
        }
    }

    const logOut = () =>{
        setLogOut(false);navigation("*")
        localStorage.clear();
        navigation("/")
    }

    const scrollToNotification = () =>{
        //notificationRef.current?.scrollIntoView();
        navigation('/notification')
    }
    return(
        <div className={styles.profile_page_container}>
            {userId==null&&<div style={{position:"fixed", top:"5px", right:"15px", zIndex:"999"}}><img src={notification} onClick={()=>scrollToNotification()}/></div>}
            <div className={styles.profile_page_header_container} >
                {userId!=null?
                <div style={{flex:"1"}} 
                    onClick={()=>{
                        dispathc(setProfileId(null))
                        navigation(-1)
                        }}>
                        <img src={backButton}/>
                </div>:
                <div style={{flex:"1"}} onClick={()=>inputRef.current?.click()}>Изменить аватар</div>}
                <AvatarView>
                    {/* {avatar!=null?<img src={avatar}/>:null} */}
                    {user?.photo!=null?<Image width={"100%"} height={"100%"} src={"https://sportsrestaurant.online"+user?.photo} style={{width:"100%", objectFit:"cover"}}/>:null}
                    {/* {user?.photo!=null?<img src={"https://sportsrestaurant.online"+user?.photo} style={{width:"100%", objectFit:"cover"}}/>:null} */}
                </AvatarView>
                
                <div style={{flex:"1"}}>
                    {userId==null&&<div style={{textAlign:"end"}} onClick={()=>{setLogOut(true)}}>Выйти из профиля</div>}
                </div>
            </div>
            <div className={styles.profile_page_user_name}>
                {user!=null?user.user_name:"_"}
            </div>
            {user?.awards!=null&&user?.awards.length>0&&
                <div className={styles.profile_page_avard_container}>
                    <div className={styles.profile_page_avard_content}>
                        {/* {user?.awards.map(item=>{return <img src={"https://sportsrestaurant.online"+item}/>})} */}
                        {user?.awards.map(item=>{return <Image style={{maxWidth:"80px", height:"auto"}} src={"https://sportsrestaurant.online"+item}/>})}
                    </div>
                </div>
            }
            <TextGradient
                colors={["#739E72","#1C6A93","#F65B3E"]}
                // text={mainData.distance_length.toLocaleString('ru-RU')}
                text= {user!=null?user.distance.toString():"_"}
                fontSize={"36px"}
                fontWeigth={"700"}/>
            <TextGradient
                colors={["#739E72","#1C6A93","#F65B3E"]}
                text={"ваш результат, км"}
                fontSize={"14px"}
                fontWeigth={"400"}/>
                <div style={{marginTop:"20px", display:"flex", alignItems:"center", flexDirection:"column"}}>
                    <ActivityBar/>
                    <div className={styles.profile_page_activity_resilt}>
                    {user!=null?user.activity_distance.toString():"_"}
                </div>
                <div>{getDescriptionActivity(activity,true)}</div>
                    <Table<UserProfileRateDomain>
                    columns={columns}
                    dataSource={user?.data!=null?user?.data:[]}
                    //scroll={{ y: size-120}}
                    pagination={false}/>
                </div>
            <input 
                type={'file'} 
                ref={inputRef} 
                style={{width:"0", height:"0", opacity:"0", overflow:"hidden", position:"absolute"}} 
                onChange={event =>handleFileChange(event)}
                accept={"image/jpeg"}/>
                 <Modal isOpen={loqOut}>
                        <Modal.Content isClosable={true} onClose={()=>{setLogOut(false)}}>
                            <LogOut onLogOut={()=>logOut()}/>
                        </Modal.Content>
                 </Modal>
        </div>
    )
}